module.exports = __webpack_public_path__ + "media/images/vanity-c0dc76b8.webp";